import React from 'react';
import ProductImageCard from '../ProductImageCard';
import { ProductCellColumn, ProductImageCardWrapper } from './styled';
import VerticalSpacer from '../VerticalSpacer/VerticalSpacer';
import ProductListProductInfo from '../ProductInfoCard/ProductListProductInfo';
import productInfoDataSanitizer from '../ProductInfoCard/productInfoDataSanitizer';
import withCountryCode, { BuildUrlWithCountry } from '../../components/RoutesHoc/RoutesHoc';
import { Product } from '../../common/models/Store/api/Products';
import { ResponsivenessConfig } from '../../components/ResponsiveImg/StyledResponsiveImg';

/* Types */
interface ProductCellProps {
  bright?: boolean;
  currencySymbol: string;
  height?: string;
  hidePrice?: boolean;
  isDesktop?: boolean;
  lazyLoad?: boolean;
  placeholderHeight?: string;
  placeholderWidth?: string;
  product: Product;
  responsivenessConfig?: ResponsivenessConfig;
  s3BasePath: string;
  showSale?: boolean;
  width?: string;
}

/* Components */
const ProductCell: React.FC<ProductCellProps & { buildUrlWithCountry: BuildUrlWithCountry }> = ({
  bright,
  buildUrlWithCountry,
  currencySymbol,
  height,
  hidePrice,
  isDesktop,
  lazyLoad,
  placeholderHeight,
  placeholderWidth,
  product,
  responsivenessConfig,
  s3BasePath,
  showSale = false,
  width,
}) => {
  const DESKTOP_PRODUCT_IMAGE_WIDTH = '170px';
  const DESKTOP_PRODUCT_IMAGE_HEIGHT = '227px';

  return (
    <ProductCellColumn data-cy="product-cell" isDesktop={isDesktop}>
      <div data-cy-pid={product.product_id} data-cy-price={product.rrp}>
        <a href={buildUrlWithCountry(product.url)} id={`pr-${product.product_id}`} style={{ textDecoration: 'none' }}>
          <ProductImageCardWrapper>
            <ProductImageCard
              height={isDesktop ? DESKTOP_PRODUCT_IMAGE_HEIGHT : height}
              images={product.images}
              lazyLoad={lazyLoad}
              padTop="0"
              placeholderHeight={placeholderHeight || (isDesktop ? DESKTOP_PRODUCT_IMAGE_HEIGHT : height)}
              placeholderWidth={placeholderWidth || (isDesktop ? DESKTOP_PRODUCT_IMAGE_WIDTH : width)}
              product={product}
              responsivenessConfig={responsivenessConfig}
              s3BasePath={s3BasePath}
              width={isDesktop ? DESKTOP_PRODUCT_IMAGE_WIDTH : width}
            />
            <VerticalSpacer height="14px" />
          </ProductImageCardWrapper>
          <ProductListProductInfo
            bright={bright}
            currencySymbol={currencySymbol}
            hidePrice={hidePrice}
            product={productInfoDataSanitizer(product)}
            showSale={showSale}
            width="100%"
          />
        </a>
      </div>
    </ProductCellColumn>
  );
};

export default withCountryCode(ProductCell);
